import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import TemplateRenderer from "../components/templates/TemplateRenderer";
import { Eye, Clock, AlertTriangle } from "lucide-react";

const PreviewPage = () => {
  const { token } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/preview/${token}`)
      .then((res) => setPage(res.data))
      .catch((e) => {
        const code = e?.response?.status;
        if (code === 410) setError({ kind: "expired", msg: "Ce lien d'aperçu a expiré (durée de vie : 24h)." });
        else if (code === 400) setError({ kind: "invalid", msg: "Ce lien d'aperçu est invalide." });
        else setError({ kind: "missing", msg: "Page introuvable." });
      });
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center text-center px-5" data-testid="preview-error">
        <div className="max-w-md">
          <div className="w-14 h-14 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-5">
            <AlertTriangle className="w-7 h-7 text-amber-600" />
          </div>
          <h1 className="font-heading font-black text-4xl tracking-tighter text-gray-900">Lien indisponible</h1>
          <p className="text-gray-600 mt-3">{error.msg}</p>
          <a href="/" className="text-blue-600 font-semibold mt-6 inline-block hover:underline">Retour à Le Guide des Entrepreneurs</a>
        </div>
      </div>
    );
  }

  if (!page) {
    return <div className="min-h-screen bg-white flex items-center justify-center text-gray-500">Chargement de l'aperçu…</div>;
  }

  return (
    <div data-testid="preview-page" className="font-preserve">
      {/* Preview banner */}
      <div className="sticky top-0 z-[60] bg-blue-600 text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-3" data-testid="preview-banner">
        <Eye className="w-4 h-4" />
        <span>Aperçu privé · cette page n'est pas encore publiée</span>
        <span className="hidden sm:inline-flex items-center gap-1 text-white/80">
          <Clock className="w-3.5 h-3.5" /> lien valide 24h
        </span>
      </div>
      <TemplateRenderer page={page} />
    </div>
  );
};

export default PreviewPage;
